export const INIT_CREDIT_CARD_ADD = 'INIT_CREDIT_CARD_ADD'
export const INIT_3DSECURE_FLOW = 'INIT_3DSECURE_FLOW'
export const CREDIT_CARD_BRAND_SELECTED = 'CREDIT_CARD_BRAND_SELECTED'
export const INGENICO_VERIFICATION_FAILED = 'INGENICO_VERIFICATION_FAILED'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const CALLBACK_URL = '/ingenico.html'
